export default __webpack_public_path__ + "static/media/dass-logo.cc1f9240.svg";